var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "collapsible-block",
    {
      ref: "collapsible",
      staticClass: "order-information",
      attrs: {
        "title-text": _vm.$t("businessOrders.labels.orderInformation"),
        "preview-only": ""
      }
    },
    [
      _c(
        "flex-row",
        {
          staticClass: "flex--no-wrap order-information__order-comments",
          attrs: { "column-spacing": "lg" }
        },
        [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "value-wrapper",
                {
                  attrs: {
                    label: _vm.$t("businessOrders.labels.orderComments")
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm._f("valueOrDash")(_vm.filteredOrderComments)) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm.businessOrder.packages.length == 0 &&
      _vm.businessOrder.pallets.length == 0
        ? _c(
            "div",
            {
              staticClass: "order-information__sku-table stick-to-modal-sides"
            },
            [
              _c(
                "table",
                { staticClass: "table table--stick-to-modal-sides" },
                [
                  _c("thead", [
                    _c("tr", { staticClass: "table__header-row" }, [
                      _c("th", { staticClass: "table__header-cell" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("businessOrders.labels.sku")) +
                            "\n                    "
                        )
                      ]),
                      _c("th", { staticClass: "table__header-cell" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t("businessOrders.labels.description")
                            ) +
                            "\n                    "
                        )
                      ]),
                      _vm.isLotTrackedOrder
                        ? _c("th", { staticClass: "table__header-cell" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t("businessOrders.labels.lotnumber")
                                ) +
                                "\n                    "
                            )
                          ])
                        : _vm._e(),
                      _vm.isLotTrackedOrder
                        ? _c("th", { staticClass: "table__header-cell" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t("businessOrders.labels.expiration")
                                ) +
                                "\n                    "
                            )
                          ])
                        : _vm._e(),
                      _c("th", { staticClass: "table__header-cell" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("businessOrders.labels.quantity")) +
                            "\n                    "
                        )
                      ])
                    ])
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.businessOrder.items, function(item) {
                      return _c(
                        "tr",
                        {
                          key: item.id,
                          staticClass: "table__body-row",
                          class: {
                            "text-error":
                              !item.isInStock ||
                              _vm.businessOrder.isUnavailableExpiredLotOrder
                          }
                        },
                        [
                          _c(
                            "td",
                            { staticClass: "table__body-cell fixsizes" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm._f("valueOrDash")(item.sku)) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _c(
                            "td",
                            { staticClass: "table__body-cell fixsizes" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm._f("valueOrDash")(item.description)
                                  ) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm.isLotTrackedOrder
                            ? _c(
                                "td",
                                {
                                  staticClass: "table__body-cell fixsizes",
                                  class: {
                                    "text-error":
                                      new Date(item.expirationDate) <=
                                      new Date()
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm._f("valueOrDash")(item.lotNumber)
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.isLotTrackedOrder
                            ? _c(
                                "td",
                                {
                                  staticClass: "table__body-cell fixsizes",
                                  class: {
                                    "text-error":
                                      new Date(item.expirationDate) <=
                                      new Date()
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm._f("valueOrDash")(
                                          _vm._f("date")(
                                            item.expirationDate,
                                            "short"
                                          )
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c("td", { staticClass: "table__body-cell" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm._f("valueOrDash")(item.quantity)) +
                                "\n                    "
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }